import api from "@/api";


 //所有指标查询
export const getidFiconPage = () => { 
    return api.axss("post", `/ocm-oil-site/oil-site-identifier-icon/page`,{size:999,current:1})
}

//用户指标查询
export const oilSiteTypeModel = (data) => { 
    return api.axss("post", `/ocm-oil-site/oil-site-type-model/page`,data)
}


//用户指标删除
export const typeSiteDel = (data) => { 
    return api.axss("post", ` /ocm-oil-site/oil-site-type-model/delete?id=${data.id}&iotInstanceId=${data.iotInstanceId}`,)
}

//批量添加
export const batchInsert = (data) => { 
    return api.axss("post", `/ocm-oil-site/oil-site-type-model/batchInsert`,data)
}

//批量删除
export const batchDelete = (data) => { 
    return api.axss("post", `/ocm-oil-site/oil-site-type-model/batchDelete`,data)
}

 //租户查询
 export const detailByTenant = (id) => { 
    return api.axss("get", `/ocm-oil-site/oil-site-identifier-icon/detailByTenant?tenantId=${id}`,)
}

 //租户设置可见度
 export const updateByTenant = (data) => { 
    return api.axss("post", `/ocm-oil-site/oil-site-identifier-icon/updateByTenant`,data)
}

 //下载模型
 export const josndownload = (id) => { 
    return api.arrbuff("get", `/ocm-oil-site/oil-site-type/model/json/download?id=${id}`)
}


 //开启关闭测试租户
 export const testTenant = (data) => { 
    return api.axss("post", `/ocm-admin/tenant/open/testTenant`,data)
}

